import React, { useState, useEffect } from "react";
import jwt from "jsonwebtoken";
import { jwtSecret } from "../config";
import {
    apiCallingWithoutToken,
    setAuthTokens,
    apiCalling
} from "../apiService";
import { authHelper, setIsAuthenticated } from "../utilis/authHelper";

const Login = ({ onClose, bookAppoinmentSubmit }) => {
    const [step, setStep] = useState("mobile"); // 'mobile' | 'otpLogin' | 'registerInfo' | 'registerOtp'
    const [isDoctorLogin, setIsDoctorLogin] = useState(false);
    const [username, setUsername] = useState("");
    const [loginpassword, setLoginpassword] = useState("");
    const [otp, setOtp] = useState("");
    const [emailId, setEmailId] = useState("");
    const [name, setName] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [canResend, setCanResend] = useState(false); // New state for resend delay
    const [resendTimer, setResendTimer] = useState(0);
    const clearMessage = () => {
        setTimeout(() => {
            setErrorMsg("");
            setSuccessMsg("");
        }, 5000);
    };
    const RESEND_DELAY_SECONDS = 10;
    const startResendTimer = () => {
        setCanResend(false);
        setResendTimer(RESEND_DELAY_SECONDS);

        const interval = setInterval(() => {
            setResendTimer(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(interval);
                    setCanResend(true);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    };
    /** --------------------------
     * STEP 1 - MOBILE SUBMIT
     * -------------------------- */
    const handleMobileSubmit = async () => {
        setErrorMsg("");
        setSuccessMsg("");
        const phoneno = /^[0-9]{10}$/;
        if (!username) {
            setErrorMsg("Please enter registered Mobile Number");
            clearMessage();
            return;
        } else if (!phoneno.test(username)) {
            setErrorMsg("Invalid Mobile Number");
            clearMessage();
            return;
        }

        // const token = jwt.sign(
        //     {
        //         username: username,
        //         password: loginpassword,
        //     },
        //     jwtSecret()
        // );

        const loginOTPRequest = {
            method: "POST",
            body: JSON.stringify(
                {
                    "functionName": "userRegister",
                    "mobileNumber": username,
                    "emailId": "",
                    "name": "",
                    "siteId": window.sessionStorage.getItem("siteId"),
                    "otp": ""

                }
                //     {
                //     functionName: "login",
                //     token: token,
                //     siteId: window.sessionStorage.getItem("siteId"),
                //     otp: "",
                //   }
            ),
        };

        try {
            setLoading(true);
            const data = await apiCallingWithoutToken(loginOTPRequest);
            if (data.success === "0") {
                // mobile not registered — go to registration info step
                if (data.errorMessage === "Mobile number already exist with another role") {
                    setErrorMsg(data.errorMessage);
                    return
                }
                setSuccessMsg("Mobile number not submited.");
                setStep("registerInfo");

            } else if (data.success === "1") {
                // otp sent for existing user
                setStep("otpLogin");
                setSuccessMsg("OTP has been sent to your Mobile Number");
                startResendTimer();
            } else {
                setErrorMsg(data.errorMessage || "Unexpected response.");
            }
        } catch (err) {
            setErrorMsg("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
            clearMessage();
        }
    };

    /** --------------------------
     * STEP 2 - EXISTING USER LOGIN VIA OTP
     * -------------------------- */
    const handleOtpLogin = async () => {
        debugger
        if (!otp) {
            setErrorMsg("OTP required");
            clearMessage();
            return;
        }
        const OTPVerifiedLoginRequest = {
            method: "POST",
            body: JSON.stringify(
                {
                    "functionName": "userRegister",
                    "mobileNumber": username,
                    "emailId": "",
                    "name": "",
                    "siteId": window.sessionStorage.getItem("siteId"),
                    "otp": otp

                }

            ),
        };

        try {
            setLoading(true);
            const data = await apiCallingWithoutToken(OTPVerifiedLoginRequest);
            if (data.success === "1") {
                setSuccessMsg("Logged in Successfully");
                if (data.userData) {
                    authHelper.setLogin(data.userData[0]);
                    setAuthTokens(
                        data.userData[0]?.accessToken,
                        data.userData[0]?.refreshToken
                    );
                    setIsAuthenticated(true);
                    window.sessionStorage.setItem("isLogin", "true");
                    window.sessionStorage.setItem(
                        "userName",
                        data.userData[0].userName
                    );
                    window.sessionStorage.setItem(
                        "mobileNumber",
                        data.userData[0].mobileNumber
                    );

                    //   const role = data.userData[0].role;
                    //   if (role === "ROLE_DOCTOR") {
                    //     window.location.href = "/doctor/dashboard";
                    //   } else if (role === "ROLE_USER") {
                    //     window.location.href = "/patient/bookappointment";
                    //   } else if (
                    //     role === "ROLE_ADMIN" ||
                    //     role === "ROLE_GROUPHOSPITALADMIN"
                    //   ) {
                    //     window.location.href = "/admin/dashboard";
                    //   }
                    onClose()
                    setTimeout(() => {
                        bookAppoinmentSubmit()
                        // window.location.reload();
                    }, 1000);
                }
            } else {
                setErrorMsg(data.successMessage || "Invalid OTP");
            }
        } catch (err) {
            setErrorMsg("Something went wrong during login.");
        } finally {
            setLoading(false);
            clearMessage();
        }
    };

    /** --------------------------
     * STEP 3A - REGISTER INFO SUBMIT
     * -------------------------- */
    const handleRegisterInfoSubmit = async () => {
        debugger
        if (!name) {
            setErrorMsg("Name required");
            clearMessage();
            return;
        }
        if (!emailId) {
            setErrorMsg("Email ID required");
            clearMessage();
            return;
        }
        // const token = jwt.sign(
        //     {
        //         username: username,
        //         password: loginpassword,
        //     },
        //     jwtSecret()
        // );

        const loginOTPRequest = {
            method: "POST",
            body: JSON.stringify(
                {
                    "functionName": "userRegister",
                    "mobileNumber": username,
                    "emailId": emailId,
                    "name": name,
                    "siteId": window.sessionStorage.getItem("siteId"),
                    "otp": ""

                }
                //     {
                //     functionName: "login",
                //     token: token,
                //     siteId: window.sessionStorage.getItem("siteId"),
                //     otp: "",
                // }
            ),
        };

        try {
            setLoading(true);
            const data = await apiCallingWithoutToken(loginOTPRequest);
            setStep("registerOtp");
            setSuccessMsg("OTP sent for registration.");
            startResendTimer();
            //   if (data.success === "1") {
            //     setStep("registerOtp");
            //     setSuccessMsg("OTP sent for registration.");
            //   } else {
            //     setErrorMsg("Failed to send OTP for registration.");
            //   }
        } catch {
            setErrorMsg("Something went wrong while sending OTP.");
        } finally {
            setLoading(false);
            clearMessage();
        }
    };

    /** --------------------------
     * STEP 3B - REGISTER SUBMIT WITH OTP
     * -------------------------- */
    const handleRegisterSubmit = async () => {
        debugger
        if (!otp) {
            setErrorMsg("OTP required");
            // clearMessage();
            return;
        }

        const registerData = {
            method: "POST",
            body: JSON.stringify({
                functionName: "userRegister",
                mobileNumber: username,
                emailId: emailId,
                name: name,
                siteId: window.sessionStorage.getItem("siteId"),
                otp: otp,
            }),
        };

        try {
            setLoading(true);
            const data = await apiCallingWithoutToken(registerData);
            if (data.success === "1") {
                setSuccessMsg("Registration successful. Logging in...");
                authHelper.setLogin(data.userData[0]);
                setAuthTokens(
                    data.userData[0]?.accessToken,
                    data.userData[0]?.refreshToken
                );
                setIsAuthenticated(true);
                window.sessionStorage.setItem("isLogin", "true");
                window.sessionStorage.setItem(
                    "userName",
                    data.userData[0].userName
                );
                window.sessionStorage.setItem(
                    "mobileNumber",
                    data.userData[0].mobileNumber
                );
                onClose()

                setTimeout(() => {
                    bookAppoinmentSubmit()
                    // window.location.reload();
                }, 1000);
            } else {
                setErrorMsg(data.errorMessage || "Registration failed.");

            }
        } catch (err) {
            setErrorMsg("Something went wrong during registration.");
        } finally {
            setLoading(false);
            clearMessage();
        }
    };

    /** --------------------------
     * RESEND OTP
     * -------------------------- */
    const resendOtp = async () => {
        if (!canResend) {
            setErrorMsg(`Please wait ${resendTimer} seconds before resending.`);
            clearMessage();
            return;
        }
        // const token = jwt.sign(
        //     {
        //         username: username,
        //         password: loginpassword,
        //     },
        //     jwtSecret()
        // );

        const ResendOTPRequest = {
            method: "POST",
            body: JSON.stringify(
                {
                    "functionName": "userRegister",
                    "mobileNumber": username,
                    "emailId": emailId,
                    "name": name,
                    "siteId": window.sessionStorage.getItem("siteId"),
                    "otp": ""

                }
            ),
        };

        try {
            setLoading(true);
            const data = await apiCallingWithoutToken(ResendOTPRequest);
            if (data.success === "1") {
                setSuccessMsg("OTP resent successfully.");
                startResendTimer();
            } else {
                setErrorMsg("Failed to resend OTP.");
            }
        } catch {
            setErrorMsg("Error resending OTP.");
        } finally {
            setLoading(false);
            clearMessage();
        }
    };

    /** --------------------------
     * JSX RENDER
     * -------------------------- */
    return (
        <div className="popup-outer-div">
            <div className="popup-overlay signInPopup">
                <div className="popup-content">
                    <div className="modal-popup">
                        <div
                            className="close-popup popup-login-hide"
                            style={{ lineHeight: 1 }}
                            title="close"
                            onClick={() => {
                                setUsername("");
                                setOtp("");
                                setEmailId("");
                                setName("");
                                setErrorMsg("");
                                setSuccessMsg("");
                                setStep("mobile");
                                if (onClose) onClose();
                            }}
                        >
                            &times;
                        </div>

                        <div className="signInHead">
                            <h2>Book Appoinment </h2>
                            {errorMsg && (
                                <p style={{ color: "red", fontSize: "12px" }}>{errorMsg}</p>
                            )}
                            {successMsg && (
                                <p style={{ color: "green", fontSize: "12px" }}>{successMsg}</p>
                            )}
                        </div>

                        <div className="signInBody">
                            {/* Step 1: Mobile input */}
                            {step === "mobile" && (
                                <>
                                    <input
                                        type="text"
                                        name="username"
                                        value={username}
                                        className="input-design my-2"
                                        placeholder="Mobile Number"
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                    <div className="signInButton">
                                        <button
                                            className="formButtonBg"
                                            onClick={handleMobileSubmit}
                                            disabled={loading}
                                        >
                                            {loading ? "Please wait..." : "Submit"}
                                        </button>
                                    </div>
                                </>
                            )}

                            {/* Step 2: OTP Login */}
                            {step === "otpLogin" && (
                                <>
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            type="text"
                                            name="otp"
                                            value={otp}
                                            className="input-design input-design-edit"
                                            placeholder="OTP"
                                            onChange={(e) => setOtp(e.target.value)}
                                        />
                                        {/* <button className="resend-btn" onClick={resendOtp}>
                                    Resend 
                                </button> */}
                                        {/* <button
                                            className="resend-btn"
                                            onClick={resendOtp}
                                            disabled={!canResend || loading} // Button is disabled if resend isn't allowed or is loading
                                        >
                                            {canResend ? "Resend" : `Resend (${resendTimer})`}
                                        </button> */}
                                        <button
                                            className="resend-btn"
                                            onClick={handleOtpLogin}
                                            disabled={loading}
                                        >
                                            {loading ? "Please wait..." : "Submit"}
                                        </button>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-end mt-3">
                                        <button
                                            className="formButtonBg mr-2"
                                            onClick={() => {
                                                setOtp("");
                                                setStep("mobile");
                                                setErrorMsg("");
                                                setSuccessMsg("");
                                                setCanResend(false);
                                                setResendTimer(0);
                                            }}
                                        >
                                            Back
                                        </button>
                                         <button
                                            className="formButtonBg"
                                            onClick={resendOtp}
                                            disabled={!canResend || loading} // Button is disabled if resend isn't allowed or is loading
                                        >
                                            {canResend ? "Resend" : `Resend (${resendTimer})`}
                                        </button>
                                        {/* <button
                                            className="formButtonBg"
                                            onClick={handleOtpLogin}
                                            disabled={loading}
                                        >
                                            {loading ? "Please wait..." : "Sign In"}
                                        </button> */}
                                    </div>
                                </>
                            )}

                            {/* Step 3A: Registration Info */}
                            {step === "registerInfo" && (
                                <>
                                    <input
                                        type="text"
                                        name="name"
                                        value={name}
                                        className="input-design my-2"
                                        placeholder="Name"
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <input
                                        type="email"
                                        name="emailId"
                                        value={emailId}
                                        className="input-design my-2"
                                        placeholder="Email ID"
                                        onChange={(e) => setEmailId(e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        name="username"
                                        value={username}
                                        className="input-design my-2"
                                        placeholder="Mobile Number"
                                    // readOnly
                                    />
                                    <div className="signInButton">
                                        <button
                                            className="formButtonBg"
                                            onClick={handleRegisterInfoSubmit}
                                            disabled={loading}
                                        >
                                            {loading ? "Please wait..." : "Submit"}
                                        </button>
                                    </div>
                                </>
                            )}

                            {/* Step 3B: Registration OTP */}
                            {step === "registerOtp" && (
                                <>
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            type="text"
                                            name="otp"
                                            value={otp}
                                            className="input-design input-design-edit"
                                            placeholder="OTP"
                                            onChange={(e) => setOtp(e.target.value)}
                                        />
                                        <button
                                            className="resend-btn"
                                            onClick={handleRegisterSubmit}
                                            disabled={loading}
                                        >
                                            {loading ? "Please wait..." : "Submit"}
                                        </button>

                                    </div>
                                    <div className="d-flex align-items-center justify-content-end mt-3">
                                        <button
                                            className="formButtonBg mr-2"
                                            onClick={() => {
                                                setOtp("");
                                                setStep("registerInfo");
                                                setErrorMsg("");
                                                setSuccessMsg("");
                                            }}
                                        >
                                            Back
                                        </button>
                                        <button className="formButtonBg" onClick={resendOtp}>
                                            Resend
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
